import React from 'react';
import './index.css';

type TextInputProps = {
    className?: string;
    id?: string;
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    type?: React.HTMLInputTypeAttribute;
    value?: string;
    disabled?: boolean;
};

function TextInput({
    className,
    id,
    name,
    onChange,
    label,
    placeholder,
    required,
    type,
    value,
    disabled
}: TextInputProps) {
    return (
        <div className={`textInput2 ${className}`}>
            {label && <p className='textInput2__label'>{label} {required && '*'}</p>}
            <input
                className='textInput2__input'
                id={id}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                type={type}
                value={value}
                disabled={disabled}
            />
        </div>
    );
}

export default TextInput;